import { render, staticRenderFns } from "./Delete-Prompt.vue?vue&type=template&id=145dd68e&scoped=true&"
import script from "./Delete-Prompt.vue?vue&type=script&lang=js&"
export * from "./Delete-Prompt.vue?vue&type=script&lang=js&"
import style0 from "./Delete-Prompt.vue?vue&type=style&index=0&id=145dd68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145dd68e",
  null
  
)

export default component.exports